import VendorScreen from './index';

const routes = [
  {
    path: '/onboarding-vendor',
    component: VendorScreen,
  },
];

export default routes;
